import React, { useEffect, useState } from "react";
import {
  formatABN,
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatedInternationalAddress,
  formatMobile,
  formatName,
  // formatNumber,
  formatPhone,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { getVendorDetail } from "./VendorHelper";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import DetailPhotoBody from "../../components/DetailPhotoBody";
import { cddOptions, riskProfile, verificationMethods } from "../../config";
import VendorSummary from "../Reports/Statements/VendorSummary";
import { Button } from "../../components/ui/button";
import { useOrganization } from "../../lib/context/OrganisationContext";

const VendorDetailsPopup = ({
  vendorId,
  // toggleShowModal,
  org,
  showView,
  setShowView,
  trustId,
  vendor,
}) => {
  const { organizationData } = useOrganization();

  const [vendorDetail, setVendorDetail] = useState(null);
  const [vendorLoading, setVendorLoading] = useState(true);
  const [showStatement, setShowStatement] = useState(null);

  const toggleStatement = () => {
    setShowStatement(!showStatement);
  };

  useEffect(() => {
    async function fetchData() {
      const vendorDetailData = await getVendorDetail(vendorId);
      setVendorDetail(vendorDetailData);
      setVendorLoading(false);
    }
    fetchData();
  }, [vendorId, setVendorDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={`${getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor"
      )} Details`}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      <>
        {vendorLoading ? (
          <Spin full expand={true} />
        ) : (
          <div className="md:p-0 p-4">
            <DetailPhotoBody
              textValue={vendorDetail?.first_name?.charAt(0)}
              imgURL={vendorDetail?.profile_pic}
              profileName={
                vendorDetail?.business_name
                  ? vendorDetail?.business_name
                  : formatName(
                      vendorDetail?.first_name,
                      vendorDetail?.last_name
                    )
              }
            />
            <div className="modal-content">
              <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                Personal Details{" "}
                {!org && <div>
                  <Button
                    className="p-2 h-6 mb-1.5"
                    onClick={() => {
                      toggleStatement();
                    }}
                  >
                    View Statement
                  </Button>
                </div>}
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                {org && <p>
                  <strong>Trust:</strong>{" "}
                  {vendorDetail?.trust ? formatSubcontractorName(vendorDetail?.trust) : "AML-CTF"}
                </p>}
                <p>
                  <strong>First Name:</strong>{" "}
                  {vendorDetail?.first_name ? vendorDetail?.first_name : "-"}
                </p>
                <p>
                  <strong>Last Name:</strong> {vendorDetail?.last_name}
                </p>
                <p>
                  <strong>Email Address:</strong> {vendorDetail?.email}
                </p>
                <p>
                  <strong>Phone Number:</strong>{" "}
                  {vendorDetail?.phone ? formatPhone(vendorDetail?.phone) : ""}
                </p>
                <p>
                  <strong>Mobile Number:</strong>{" "}
                  {vendorDetail?.mobile
                    ? formatMobile(vendorDetail?.mobile)
                    : "-"}
                </p>
                <p>
                  <strong>Business Name:</strong>{" "}
                  {vendorDetail?.business_name
                    ? vendorDetail?.business_name
                    : "-"}
                </p>
                <p>
                  <strong>Business Email:</strong>{" "}
                  {vendorDetail?.business_email
                    ? vendorDetail?.business_email
                    : "-"}
                </p>
                <p>
                  <strong>ABN:</strong>{" "}
                  {vendorDetail?.abn ? formatABN(vendorDetail?.abn) : "-"}
                </p>
                <p>
                  <strong>Code:</strong>{" "}
                  {vendorDetail?.code ? vendorDetail?.code : "-"}
                </p>
                <p>
                  <strong>Date of Birth:</strong>{" "}
                  {vendorDetail?.dob ? vendorDetail?.dob : "-"}
                </p>
                <p className="flex gap-1">
                  <strong className="whitespace-nowrap">Postal Address:</strong>{" "}
                  {vendorDetail?.international_address
                    ? formatedInternationalAddress(
                        vendorDetail?.full_address,
                        vendorDetail?.country?.name
                      )
                    : formatedAddress(
                        vendorDetail?.street,
                        vendorDetail?.suburb?.name,
                        vendorDetail?.state?.name,
                        vendorDetail?.postal_code
                      )}
                </p>
                <p className="flex gap-1">
                  <strong className="whitespace-nowrap">Street Address:</strong>{" "}
                  {vendorDetail?.shipping_international_address
                    ? formatedInternationalAddress(
                        vendorDetail?.shipping_full_address,
                        vendorDetail?.shipping_country?.name
                      )
                    : formatedAddress(
                        vendorDetail?.shipping_street,
                        vendorDetail?.shipping_suburb?.name,
                        vendorDetail?.shipping_state?.name,
                        vendorDetail?.shipping_postal_code
                      )}
                </p>
              </div>
            </div>
            {vendorDetail?.account_name && (
              <div className="modal-content mt-4">
                <CardTitle className="text-md mb-2">
                  Bank Account Details
                </CardTitle>
                <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                  <p>
                    <strong>Bank Name:</strong>{" "}
                    {vendorDetail?.bank
                      ? vendorDetail?.bank?.abbreviation +
                        "-" +
                        vendorDetail?.bank?.name
                      : "-"}
                  </p>
                  <p>
                    <strong>Bank Account Name:</strong>{" "}
                    {vendorDetail?.account_name
                      ? vendorDetail?.account_name
                      : "-"}
                  </p>
                  <p>
                    <strong>BSB:</strong>{" "}
                    {vendorDetail?.bsb
                      ? formatBSBNumber(vendorDetail?.bsb)
                      : "-"}
                  </p>
                  <p>
                    <strong>Account Number:</strong>{" "}
                    {vendorDetail?.account_number
                      ? formatAccountNumber(vendorDetail?.account_number)
                      : "-"}
                  </p>
                  {/* <p>
                    <strong>Opening Balance:</strong>{" "}
                    {vendorDetail?.opening_balance
                      ? "$" +
                        formatNumber(Number(vendorDetail?.opening_balance))
                      : "$0.00"}
                  </p> */}
                </div>
              </div>
            )}

            {vendorDetail?.kyc && (
              <div className="modal-content mt-4">
                <CardTitle className="text-md mb-2">
                  Proof of ID for Vendor Verification (KYC)
                </CardTitle>
                <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                  {vendorDetail?.kyc?.photo_id && (
                    <p>
                      <strong>Photo ID:</strong>{" "}
                      <a
                        href={vendorDetail.kyc.photo_id}
                        download
                        target="_blank"
                        className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                        rel="noreferrer"
                      >
                        Download
                      </a>
                    </p>
                  )}
                  {vendorDetail?.kyc?.primary_id && (
                    <p>
                      <strong>Primary ID:</strong>{" "}
                      <a
                        href={vendorDetail.kyc.primary_id}
                        download
                        target="_blank"
                        className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                        rel="noreferrer"
                      >
                        Download
                      </a>
                    </p>
                  )}
                  {vendorDetail?.kyc?.secondary_id && (
                    <p>
                      <strong>Secondary ID:</strong>{" "}
                      <a
                        href={vendorDetail.kyc.secondary_id}
                        download
                        target="_blank"
                        className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                        rel="noreferrer"
                      >
                        Download
                      </a>
                    </p>
                  )}
                  <p>
                    <strong>Verification Date:</strong>{" "}
                    {vendorDetail?.kyc?.verification_date
                      ? vendorDetail?.kyc?.verification_date
                      : "-"}
                  </p>
                  <p>
                    <strong>Verified By:</strong>{" "}
                    {vendorDetail?.kyc?.verified_by_user
                      ? formatSubcontractorName(
                          vendorDetail?.kyc?.verified_by_user
                        )
                      : "-"}
                  </p>
                  <p>
                    <strong>Method:</strong>{" "}
                    {vendorDetail?.kyc?.method
                      ? verificationMethods?.find(
                          (item) => item.value === vendorDetail?.kyc?.method
                        )?.label
                      : "-"}
                  </p>
                  <p>
                    <strong>Risk Profile:</strong>{" "}
                    {vendorDetail?.kyc?.risk
                      ? riskProfile?.find(
                          (item) => item.value === vendorDetail?.kyc?.risk
                        )?.label
                      : "-"}
                  </p>
                  <p>
                    <strong>CDD:</strong>{" "}
                    {vendorDetail?.kyc?.cdd
                      ? cddOptions?.find(
                          (item) => item.value === vendorDetail?.kyc?.cdd
                        )?.label
                      : "-"}
                  </p>
                </div>
              </div>
            )}

            {vendorDetail?.joint_accounts?.length > 0 && (
              <div className="modal-content">
                <CardTitle className="text-md mb-2 flex justify-between w-full items-center">
                  Joint Account
                </CardTitle>
                {vendorDetail?.joint_accounts?.map((jointItem, jointIndex) => (
                  <>
                    {jointIndex !== 0 && <hr className="my-2" />}
                    <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                      <p>
                        <strong>First Name:</strong>{" "}
                        {jointItem?.first_name ? jointItem?.first_name : "-"}
                      </p>
                      <p>
                        <strong>Last Name:</strong>{" "}
                        {jointItem?.last_name ? jointItem?.last_name : "-"}
                      </p>
                      <p>
                        <strong>Date of Birth:</strong>{" "}
                        {jointItem?.dob ? jointItem?.dob : "-"}
                      </p>
                      <p className="flex gap-1">
                        <strong className="whitespace-nowrap">Address:</strong>{" "}
                        {jointItem?.international_address
                          ? formatedInternationalAddress(
                              jointItem?.full_address,
                              jointItem?.country?.name
                            )
                          : formatedAddress(
                              jointItem?.street,
                              jointItem?.suburb?.name,
                              jointItem?.state?.name,
                              jointItem?.postal_code
                            )}
                      </p>
                      <p>
                        <strong>Bank Name:</strong>{" "}
                        {jointItem?.bank
                          ? jointItem?.bank?.abbreviation +
                            "-" +
                            jointItem?.bank?.name
                          : "-"}
                      </p>
                      <p>
                        <strong>Bank Account Name:</strong>{" "}
                        {jointItem?.account_name
                          ? jointItem?.account_name
                          : "-"}
                      </p>
                      <p>
                        <strong>BSB:</strong>{" "}
                        {jointItem?.bsb ? formatBSBNumber(jointItem?.bsb) : "-"}
                      </p>
                      <p>
                        <strong>Account Number:</strong>{" "}
                        {jointItem?.account_number
                          ? formatAccountNumber(jointItem?.account_number)
                          : "-"}
                      </p>
                    </div>
                  </>
                ))}
              </div>
            )}
          </div>
        )}
        <ResponsiveDrawerForm
          description={""}
          title={`${getModuleNamingBySlug(
            organizationData?.organizationData,
            "vendors",
            "Vendor"
          )} Statment`}
          handleOpen={() => {}}
          handleClose={() => {}}
          className={"md:w-[90vw]"}
          open={showStatement}
          buttonClassName={""}
          setOpen={setShowStatement}
          read={true}
        >
          <VendorSummary id={vendorId} trustId={trustId} vendor={vendor} />
        </ResponsiveDrawerForm>
      </>
    </ResponsiveDrawerForm>
  );
};

export default VendorDetailsPopup;
